import {
  LegacyCard,
  SkeletonBodyText,
  TextContainer,
  SkeletonDisplayText,
} from '@shopify/polaris';

const LoadingPlaceholder = () => {
  return(
    <LegacyCard sectioned>
      <TextContainer>
        <SkeletonDisplayText size="small" />
        <SkeletonBodyText />
      </TextContainer>
    </LegacyCard>
  )
}

export default LoadingPlaceholder;
